/*
 * File: CustomModal.tsx
 * Project: a-a
 * File Created: Thursday, 19th December 2024 11:28:23 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 13th June 2025 5:22:40 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Modal } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

export default function CustomModal({
  children,
  handleClose,
  open,
}: {
  children: ReactElement;
  handleClose: () => any;
  open: boolean;
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      {children}
    </Modal>
  );
}
